export { SharedClassNames }

let SharedClassNames = Object.freeze({
    IGNORE_BLUR: 'ignore-blur',
    RETURN_FOCUS: 'return-focus'
})